/*
 * @Author: sail web admin
 * @Date: 2020-04-23 16:20:03
 * @Last Modified by: vicshang
 * @Last Modified time: 2020-09-29 15:28:42
 * 英文文案
 */
import common from './common';
import login from './login';

export default {
  CurrentLan: 'Current language',
  SystemName: 'System Admin Scaffold',
  HomePage: 'Home',
  UserManager: 'Loan User Manager',
  UserList: 'User List',
  UserInfo: 'User information',
  ProjectManager: 'Project Manager',
  ProjectList: 'Project List',
  CreateProject: 'Create Project',
  ApplyLoan: 'Apply Loan',
  RiskAudit: 'Risk Audit',
  LoanOrder: 'Loan Order',
  OrderList: 'Order List',
  RepaymentList: 'Repayment List',
  WithdrawalList: 'Withdrawal List',
  RepaymentPlanList: 'Repayment plan List',
  SystemManager: 'System Manager',
  SystemUser: 'System User',
  RoleManager: 'Role Manager',
  PromissionManager: 'Promission Manager',
  Login: 'Login',
  TestManager: 'Test Demo',
  // 公共
  Common: common,
  // 登录
  LoginModule: login
};
